import React from 'react';
import styled from 'styled-components';
import { TokenSet } from '../../styles/tokens';

interface AvatarProps {
  animal?: string | null;
  name: string;
  size?: number;
  tokens: TokenSet;
}

const Circle = styled.div<{ size: number; tokens: TokenSet }>`
  width: ${p => p.size}px;
  height: ${p => p.size}px;
  border-radius: 50%;
  background: ${p => p.tokens.primary};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${p => Math.round(p.size * 0.52)}px;
  font-weight: 700;
  text-transform: uppercase;
  flex-shrink: 0;
`;

export const Avatar: React.FC<AvatarProps> = ({ animal, name, size = 36, tokens }) => (
  <Circle size={size} tokens={tokens}>
    {animal ?? name.charAt(0)}
  </Circle>
);
